export interface PermissionApiResource {
  id: string;
  code: string;
  resource: string;
  action: string;
  scope_code: string;
  description: string | null;
}

export interface Permission {
  id: string;
  code: string;
  resource: string;
  action: string;
  scopeCode: string;
  description: string | null;
}

export interface RoleApiResource {
  id: string;
  code: string;
  name: string;
  description: string | null;
  scope_code: string;
  is_system: boolean;
  created_at: string;
  updated_at: string;
}

export interface Role {
  id: string;
  code: string;
  name: string;
  description: string | null;
  scopeCode: string;
  isSystem: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface RoleDetailApiResource extends RoleApiResource {
  permission_ids: string[];
}

export interface RoleDetail extends Role {
  permissionIds: string[];
}

export interface CreateRolePayload {
  name: string;
  description: string;
  scopeCode: string;
  permissionIds: string[];
}

export function mapApiResourceToPermission(resource: PermissionApiResource): Permission {
  return {
    id: resource.id,
    code: resource.code,
    resource: resource.resource,
    action: resource.action,
    scopeCode: resource.scope_code,
    description: resource.description,
  };
}

export function mapApiResourceToRole(resource: RoleApiResource): Role {
  return {
    id: resource.id,
    code: resource.code,
    name: resource.name,
    description: resource.description,
    scopeCode: resource.scope_code,
    isSystem: resource.is_system,
    createdAt: resource.created_at,
    updatedAt: resource.updated_at,
  };
}

export function mapApiResourceToRoleDetail(resource: RoleDetailApiResource): RoleDetail {
  return {
    ...mapApiResourceToRole(resource),
    permissionIds: resource.permission_ids,
  };
}
